/** Chave localStorage do idioma ativo (compartilhada com interceptor e LanguageService). */
export const APP_LANG_STORAGE_KEY = 'app_lang';
